<script setup>
import { Link } from '@inertiajs/vue3'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'
import ProjectCard from '@/pages/projects/partials/ProjectCard.vue'
import { index as projectIndex } from '@/actions/App/Http/Controllers/ProjectController'

defineProps({
    projects: {
        type: Array,
        required: true,
    },
})
</script>

<template>
    <section v-if="projects.length > 0">
        <div class="flex flex-col items-center justify-between gap-6 sm:flex-row">
            <div>
                <p class="text-brand-primary text-sm font-semibold tracking-wider uppercase">Naše realizace</p>
                <h2 class="heading-2 mt-2">Vybrané projekty</h2>
                <p class="paragraph mt-4 max-w-2xl">
                    Prohlédněte si ukázky naší práce. Každý projekt je pro nás výzvou a příležitostí ukázat naše
                    řemeslné dovednosti.
                </p>
            </div>

            <Link
                :href="projectIndex()"
                class="inline-flex w-full items-center justify-center rounded-full border border-sky-500/30 bg-sky-500/10 px-6 py-3 font-semibold text-sky-500 backdrop-blur-lg transition hover:bg-sky-500/20 sm:w-auto"
            >
                Zobrazit všechny projekty
                <ArrowRightIcon class="ml-2 size-4 transition-transform group-hover:translate-x-1" />
            </Link>
        </div>

        <div class="mt-12 grid grid-cols-1 gap-2 lg:gap-6 sm:grid-cols-2 lg:grid-cols-3">
            <div
                v-for="project in projects"
                :key="project.id"
                class="group"
            >
                <ProjectCard :project="project" />
            </div>
        </div>
    </section>
</template>
